import Checkbox from 'antd-mobile/lib/checkbox';
export default Checkbox;



// WEBPACK FOOTER //
// ./components/checkbox/index.tsx